
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/patient-services/expiration",
      function () {
        return require("private-next-pages/patient-services/expiration/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/patient-services/expiration"])
      });
    }
  